import "./StatusControl.scss";
import {StatusControlProps} from "./StatusControl.model";

const StatusControl = ({ status }: StatusControlProps) => {
  const cssStatus = status ? `bubble-${status}` : "";

  return (
    <div className="status-container">
      <div className={`bubble ${cssStatus}`}>
        <span className="bubble-outer-dot">
          <span className="bubble-inner-dot" />
        </span>
      </div>
    </div>
  );
};

export default StatusControl;
